import { useCurrentRole } from './slices';

export const useRegionalDirectorIdsFilter = () => {
  const currentRole = useCurrentRole();
  return currentRole?.kind === 'lab_regional_director'
    ? ([currentRole.user_id] satisfies [number])
    : undefined;
};
